export const ACTION = '/Catalog/GetBuyingOptions';